import React from "react"
import { EmptyCard, TableSkeleton, TableView } from "../../../../../component/index.jsx"
import { ILLUSTRATION_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { PRIVILEGE_ENUM } from "../../../../../constants/PrivilegeConstants.js"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { DetailSvgIcon } from "../../../../../component/atoms/Icons/SVG/index.jsx"
import {
  formatterRowComponent,
  initialFilterTable
} from "../../../../../component/atoms/Tabel/index.jsx"
import { sortCaret } from "../../../../../_metronic/_helpers/index.js"
import { useTranslation } from "react-i18next"
import { loadUserLogin } from "../../../../service/userManagementAction.js"
import { stringFormatting, toMeter, toRupiah } from "../../../../helpers/TextHelper.js"
import { timeStampToDate } from "../../../../helpers/DateHelper.js"
import { AREA_REGISTERED_ENUM, DATE_TYPE_ENUM } from "../../../../../constants/StringConstant.js"
import { getUrlParsingPageFilter } from "../../../../../config/EndpointCollection.js"
import { useLocation } from "react-router"
import { getHSTUnit } from "../../../../helpers/StringCollection.js"

export const ListPaid = ({
  data,
  changePage,
  history,
  general,
  isFilter,
  selectedRows,
  setSelectedRows
}) => {
  const { t } = useTranslation()
  const privileges = loadUserLogin().privilege
  const location = useLocation()

  const uiArea = (e) => {
    return (
      <>
        <p className="text-dark font-weight-bolder mb-1 font-size-lg">
          {stringFormatting(e?.name)}
        </p>
        <span className="text-muted font-weight-bold d-block">
          {e?.sub_district_name}, {e?.land_area ? toMeter(e?.land_area) : "-"}
        </span>
      </>
    )
  }

  const uiMitra = (e) => {
    return (
      <>
        <a className="text-dark font-weight-bolder mb-1 font-size-lg">{e?.mitra_name}</a>
        <span className="text-muted font-weight-bold d-block">{e?.mitra_phone}</span>
      </>
    )
  }

  const uiFarmer = (e) => {
    return (
      <>
        <a className="text-dark font-weight-bolder mb-1 font-size-lg">{e.farmer_name}</a>
        <span className="text-muted font-weight-bold d-block">{e.farmer_phone}</span>
      </>
    )
  }

  const uiPlant = (e) => {
    return (
      <>
        <a className="text-dark font-weight-bolder mb-1 font-size-lg">{e?.plant_type}</a>
        <span className="text-muted font-weight-bold d-block">{e?.variety}</span>
      </>
    )
  }

  const uiHarvest = (e) => {
    return (
      <div>
        <div>
          {e?.harvest_date ? timeStampToDate(e?.harvest_date, DATE_TYPE_ENUM.ISO_DATE_STRAP) : "-"}
        </div>
        <div>{getHSTUnit(e?.hst)}</div>
      </div>
    )
  }

  const uiDueDate = (e) => {
    return (
      <div>
        <div>{e?.due_date ? timeStampToDate(e?.due_date, DATE_TYPE_ENUM.ISO_DATE_STRAP) : "-"}</div>
      </div>
    )
  }

  const uiTotalBill = (e) => {
    return (
      <div>
        <div>{toRupiah(e?.total_bill || 0)}</div>
      </div>
    )
  }

  const uiAction = (e) => {
    return (
      <>
        <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Detail</Tooltip>}>
          <div
            className="btn btn-icon btn-detail btn-hover-secondary btn-sm mx-3"
            onClick={() => {
              history.push(RoutesConstants.AREA.DETAIL_AREA(AREA_REGISTERED_ENUM.MT_ACTIVE, e?.area_id))
            }}>
            <DetailSvgIcon />
          </div>
        </OverlayTrigger>
      </>
    )
  }

  const columns = [
    {
      dataField: "name",
      text: t("table_header_area_name"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiArea
      },
      sortCaret: sortCaret,
      sort: false,
      headerStyle: () => {
        return { width: "20%", paddingTop: 40 }
      }
    },
    {
      dataField: "mitra_name",
      text: t("table_header_mitra"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiMitra
      },
      sortCaret: sortCaret,
      sort: false,
      headerStyle: () => {
        return { paddingTop: 40 }
      }
    },

    {
      dataField: "farmer_name",
      text: t("table_header_farmer"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiFarmer
      },
      sortCaret: sortCaret,
      sort: false,
      headerStyle: () => {
        return { paddingTop: 40 }
      }
    },
    {
      dataField: "plant_type",
      text: t("table_header_plant_type"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiPlant
      },
      sort: false,
      headerStyle: () => {
        return { paddingTop: 40 }
      }
    },
    {
      dataField: "harvestActivityDate",
      text: t("table_header_harvest_date"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiHarvest
      },
      sortCaret: sortCaret,
      sort: true,
      onSort: (field, order) => {
        let param = getUrlParsingPageFilter({
          ...initialFilterTable,
          sort: field + "," + order
        })
        history.push({ pathname: location.pathname, search: param })
      },
      headerStyle: () => {
        return { paddingTop: 40 }
      }
    },
    {
      dataField: "dueDate",
      text: t("table_header_due_date"),
      sortCaret: sortCaret,
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiDueDate
      },
      headerStyle: () => {
        return {  width: "12%", paddingTop: 40 }
      }
    },
    {
      dataField: "totalBill",
      text: t("table_header_total_bill"),
      sortCaret: sortCaret,
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiTotalBill
      },
      headerStyle: () => {
        return {  width: "12%", paddingTop: 40 }
      }
    },
    {
      dataField: "action",
      text: t("table_header_action"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiAction
      },
      headerStyle: () => {
        return { paddingTop: 40 }
      }
    }
  ]

  return (
    <>
      {general.loading ? (
        <TableSkeleton column={8} row={10} />
      ) : data?.pageData?.length === 0 ? (
        <EmptyCard
          image={
            isFilter
              ? ILLUSTRATION_CONSTANTS.NOT_FOUND_DATA
              : ILLUSTRATION_CONSTANTS.EMPTY_STATE_DATA
          }
          body={
            isFilter
              ? t("messages_response_response_not_found_data")
              : t("messages_response_empty_state", { name: "lahan" })
          }
          subtitle={isFilter ? t("messages_response_sub_response_not_found_data") : ""}
        />
      ) : (
        ""
      )}

      <TableView
        dataTable={data?.pageData ?? []}
        loadingGetData={false}
        callbackAfterPageChange={changePage}
        columnProperties={columns}
        currentPage={data?.page?.currentPage}
        currentElement={data?.page?.currentElement}
        totalCount={data?.page?.totalCount}
        rowClasses={() => {
          return "cursor-pointer"
        }}
        keyField={"id"}
        headerColumnStyle={{ paddingTop: 40 }}
        selectable={privileges.indexOf(PRIVILEGE_ENUM.HARVEST_CONFIRMATION) > -1}
        onSelect={(row, isSelected) => {
          let rows = JSON.parse(JSON.stringify(selectedRows))
          if (isSelected) {
            rows.push(row)
          } else {
            rows = rows.filter((r) => r.id !== row.id)
          }
          setSelectedRows(rows)
        }}
        onSelectAll={(isSelect, rows) => {
          let rowses = JSON.parse(JSON.stringify(selectedRows))
          if (isSelect) {
            if (rows?.length > 0) {
              rows?.map((e) => {
                rowses.push(e)
              })
            }
          } else {
            if (rows?.length) {
              let rowsesNew = rowses
              rows?.map((row) => {
                const removeIndex = rowses.findIndex((e) => e?.id === row?.id)
                rowsesNew.splice(removeIndex, 1)
              })
              rowses = rowsesNew
            }
          }
          setSelectedRows(rowses)
        }}
      />
    </>
  )
}
